import type { SaveRecord } from "./saves";

/** Best wave reached on a level across every attempt (the defeat screen's "your best"); 0 when never played. */
export function bestStageOf(save: SaveRecord, level: number): number {
  return save.bestStage?.[String(level)] ?? 0;
}

/** Records the wave a run reached; returns the best before it and whether this run beat it. */
export function recordBestStage(save: SaveRecord, level: number, reached: number): { previous: number; isNew: boolean } {
  const previous = bestStageOf(save, level);
  if (reached > previous) save.bestStage = { ...(save.bestStage ?? {}), [String(level)]: reached };
  return { previous, isNew: reached > previous };
}

/** The stored per-level bests, or undefined when missing or malformed (an old save). */
export function parseBestStage(v: unknown): Record<string, number> | undefined {
  if (typeof v !== "object" || v === null || Array.isArray(v)) return undefined;
  const out: Record<string, number> = {};
  for (const [k, n] of Object.entries(v)) if (/^\d+$/.test(k) && Number.isInteger(n) && (n as number) >= 0) out[k] = n as number;
  return out;
}
